(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqDialogController', SpecialtyIbqDialogController);

    SpecialtyIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Specialty'];

    function SpecialtyIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Specialty) {
        var vm = this;

        vm.specialty = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specialty.id !== null) {
                Specialty.update(vm.specialty, onSaveSuccess, onSaveError);
            } else {
                Specialty.save(vm.specialty, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:specialtyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
